import { UserNotificationChannel } from "./UserNotificationChannel";

export interface Notification {
  id: number;
  createdByEmail?: string;
  createdAt: string;
  apiKeyId: string;
  deleted: boolean;
  read: boolean;
  args: any;
  entity?: NotificationEntity;
  entityId?: string;
  action?: string;
  body?: string;
  subject?: string;
  shortDescription?: string;
  type: NotificationType;
}

export interface UserNotificationListItem {
  groupKey: string;
  channels: UserNotificationChannel[];
}

export interface UpdateNotificationSettingsRequest {
  updatedSettings: UserNotificationListItem[];
}

export enum NotificationType {
  Entity = "Entity",
  Informative = "Informative",
}

export enum NotificationEntity {
  OsaWay = "OsaWay",
  Project = "Project",
  Comment = "OsaComment",
}

export enum NotificationAction {
  RouteAccessCreated = "RouteAccessCreated",
  ProjectAccessCreated = "ProjectAccessCreated",
  OsaCommentCreated = "OsaCommentCreated",
  WebAppUploadProcessed = "WebAppUploadProcessed",
  MobileAppUploadProcessed = "MobileAppUploadProcessed",
  LifeCycleStageUpdated = "LifeCycleStageUpdated",
}

export interface NotificationCounter {
  unread: number;
  total: number;
}
